import { Col, Row, Form, Input } from "antd";
import { MaskInput } from "shared/components";
import { useTranslation } from "react-i18next";
import { formCNPJValidator } from "shared/helpers/cnpj-validator";

const FormPessoaJuridica: React.FC<any> = () => {
  const { t } = useTranslation("radar");
  return (
    <Col xs={24}>
      <Row gutter={[16, 16]}>
        <Col xs={12}>
          <Form.Item
            label={t("pages.TeamRequest.companyName")}
            name="name"
            rules={[
              {
                required: true,
                message: t("pages.TeamRequest.companyNameRequired"),
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={12}>
          <Form.Item
            label={t("pages.TeamRequest.socialName")}
            name="businessName"
            rules={[
              {
                required: true,
                message: t("pages.TeamRequest.socialNameRequired"),
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={12}>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) =>
              prevValues.country !== currentValues.country
            }
          >
            {({ getFieldValue }) => {
              const country = getFieldValue("country");
              return (
                <Form.Item
                  label={t("pages.TeamRequest.cnpj")}
                  name="cnpj"
                  rules={[
                    {
                      required: country === "BR",
                      message: t("pages.TeamRequest.cnpjRequired"),
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        return formCNPJValidator(
                          value,
                          getFieldValue,
                          "cnpj",
                          t
                        );
                      },
                    }),
                  ]}
                >
                  <MaskInput mask="99.999.999/9999-99" />
                </Form.Item>
              );
            }}
          </Form.Item>
        </Col>
        <Col xs={12}>
          <Form.Item
            label={t("pages.TeamRequest.telefone")}
            name="phone"
            rules={[
              {
                required: true,
                message: t("pages.TeamRequest.telefoneRequired"),
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </Col>
  );
};

export default FormPessoaJuridica;
